import * as React from "react"
import ReferencePage from "../components/reference-page/reference-page"
import { PlayIt } from "../interfaces/reference/references/play-it-reference"

const PlayITPage = () => {
  return <ReferencePage reference={PlayIt} exclude={'playit'}/>
}

export default PlayITPage
